import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { filterStatsByLicense } from 'Store/lists/actions';

import RadioButtonGroup from 'Components/RadioButtonGroup/RadioButtonGroup';

class StatsListFilters extends React.PureComponent {
  constructor(props) {
    super(props);

    this.options = [
      { value: 'none', label: '#NoFilter' },
      { value: 'expired', label: 'Deactivated schools' },
      { value: 'active', label: 'Active schools' },
      { value: 'trial', label: 'Trials' },
      { value: 'paid', label: 'Paid' },
      { value: 'school_license', label: 'School license' },
      { value: 'classroom_license', label: 'Classroom license' },
      { value: 'homeschool_license', label: 'Homeschool license' },
    ];
  }

  render() {
    return (
      <RadioButtonGroup
        name="statsFilters"
        options={this.options}
        handleChange={value =>
          this.props.filterStatsByLicense(value, 'schools_stats')
        }
        selected={this.props.selected || 'none'}
      />
    );
  }
}

StatsListFilters.propTypes = {
  selected: PropTypes.string,
  filterStatsByLicense: PropTypes.func,
};

export default connect(false, { filterStatsByLicense })(StatsListFilters);
